import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://tomkdztopmzmiixwwfsw.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRvbWtkenRvcG16bWlpeHd3ZnN3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5OTYzODksImV4cCI6MjA4NDU3MjM4OX0._ng7y8X72heKfFUjELLe73deHLI3T0S8XWuwDBF7TOg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
